import React, {Component} from 'react';

class MainCaption extends Component {
  render() {
  	return(
	    <h1 className="mainCaption">
	      Every Flower Is A Soul <br />
	      Blossoming In Nature
	    </h1>
	);
  }
}

export default MainCaption;



// WEBPACK FOOTER //
// ./src/components/homepage/mainCaption.js